import {type ICategoryAutoListItem} from '@netx/core-category-next/schema';

export const getLabelPathFromAutoListItem = (
	autoListItem?: ICategoryAutoListItem | null,
) => {
	if (!autoListItem) return {label: '', path: ''};

	const id = autoListItem.value;
	const path = autoListItem.label;
	const pieces = path.split('/');
	const label = id === 1 ? path : pieces[pieces.length - 1];
	return {
		label,
		path,
	};
};
export default getLabelPathFromAutoListItem;
